/* Jungle Calling desktop CTA flip — mirrors the theme button-label transition; touch layouts remain static. */
(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.jc-rebuild-button, .jc-social-reels__button';

  const applyDesktopFlip = () => {
    if (!finePointer.matches) return;

    document.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.jcDesktopFlip === 'true' || button.hasAttribute('disabled')) return;

      const label = button.textContent.replace(/\s+/g, ' ').trim();
      if (!label) return;

      button.dataset.jcDesktopFlip = 'true';
      button.setAttribute('data-jc-desktop-flip', 'true');
      button.setAttribute('aria-label', label);

      const track = document.createElement('span');
      track.className = 'jc-desktop-flip__track';

      const front = document.createElement('span');
      front.className = 'jc-desktop-flip__face jc-desktop-flip__face--front';
      front.textContent = label;

      const back = document.createElement('span');
      back.className = 'jc-desktop-flip__face jc-desktop-flip__face--back';
      back.textContent = label;
      back.setAttribute('aria-hidden', 'true');

      track.append(front, back);
      button.replaceChildren(track);
    });
  };

  document.addEventListener('DOMContentLoaded', applyDesktopFlip, { once: true });
  finePointer.addEventListener?.('change', applyDesktopFlip);
})();
